import { Card, Chip, Modal, ModalContent, useDisclosure } from '@nextui-org/react'
import { FC } from 'react'
import { SelectTank } from '../../pages/SelectTank'
import { useBatchStore } from '../../store/batch/useBatchStore'
import useHomeGradeStore from '../../store/home/useHomeGradeStore'
import { SchoolState } from '../../store/school/useSchoolStore'
import type { TankRelationMap } from '../../store/group/useGroupStore'
import type { SelectedTankArray } from '@/types/view'

type SelectDepartureTankProps = {
  schoolIdList: TankRelationMap
  storedSchoolList: SchoolState
}

export const SelectDepatureTank: FC<SelectDepartureTankProps> = ({
  schoolIdList,
  storedSchoolList,
}) => {
  const { setSelectedDepTanks, selectDepTanksBorderColor, selectedDepTanks } = useHomeGradeStore()
  const {
    isOpen: isOpenDepTanks,
    onOpen: onOpenDepTanks,
    onOpenChange: onOpenChangeDepTanks,
  } = useDisclosure()
  const batches = useBatchStore((state) => state.batches)
  const batchIds = Object.keys(batches).filter(
    (batchId) => batchId !== '$empty' && batchId !== '$ungrouped',
  )

  const onSubmitDepTanksArray = (tankSelectedList: SelectedTankArray) => {
    if (tankSelectedList.length === 1) {
      setSelectedDepTanks(tankSelectedList, schoolIdList, storedSchoolList)
    }
  }
  return (
    <>
      <div className="mt-3 font-bold">Departure Tank</div>
      <Card
        key="departure"
        className={`${selectDepTanksBorderColor} border-opacity-60`}
        radius="md"
        shadow="sm"
        isPressable
        onPress={onOpenDepTanks}
      >
        <Modal
          isOpen={isOpenDepTanks}
          onOpenChange={onOpenChangeDepTanks}
          isDismissable={false}
          isKeyboardDismissDisabled={true}
          size="3xl"
          scrollBehavior="inside"
          classNames={{
            wrapper: 'z-[1500]',
            backdrop: 'z-[1450]',
            base: 'max-h-[85vh] sm:max-h-[90vh] md:max-h-[95vh]',
          }}
        >
          <ModalContent>
            {(onCloseTanks) => (
              <SelectTank
                key="departure"
                submitTankArray={onSubmitDepTanksArray}
                groupIds={[...batchIds]}
                onClose={onCloseTanks}
                limit={1}
                initialTankArray={selectedDepTanks}
              />
            )}
          </ModalContent>
        </Modal>
        <div
          className="flex flex-row flex-wrap justify-start p-1 min-h-[6rem] sm:min-h-[2.375rem] overflow-y-auto"
          style={{ touchAction: 'pan-y', WebkitOverflowScrolling: 'touch' }}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          {selectedDepTanks.map((item, index) => (
            <Chip
              key={index}
              radius="md"
              classNames={{
                base: 'border-small border-tdpldarkgrey bg-tdplsky border-opacity-60 m-1 p-0',
                content: 'font-bold',
              }}
            >
              {item.tankName}
            </Chip>
          ))}
        </div>
      </Card>
      {selectDepTanksBorderColor.includes('tdplmaroon') ? (
        <p className="m-0 text-sm font-semibold text-tdplmaroon">Please select a Departure Tank.</p>
      ) : (
        <p></p>
      )}
    </>
  )
}
